import React, { useState, useEffect } from 'react'
import { asyncGetPreview } from '../../api/preview/edit/asyncUpload'
import { FileHistory } from '../main/options/model/edit/BaseListFiles'
import ListUserFiles from '../main/options/model/edit/ListUserFiles'
import { TemplateHeaderPreview } from '../main/options/model/types'
import { tabSelected } from './SelectTab'

function SelectHistoricalFile({
    setTemplate,
    setFileName,
    tab,
    fileName
}: {
    setTemplate: (templete: TemplateHeaderPreview) => void
    setFileName: (fileName: string) => void
    tab: tabSelected
    fileName: string
}) {
    const [file, setFile] = useState<FileHistory>()

    useEffect(() => {
        const uid = file?.uid || undefined
        if (!!uid)
            asyncGetPreview(file.uid)
                .then(template => setTemplate({ ...template, fileName: file.fileName }))
                .then(() => setFileName(file.fileName))
    }, [file])
    const getFile = (): FileHistory => {
        if (fileName) {
            return {
                fileName: fileName,
                collection: '',
                time: new Date().getTime(),
                sheetIndex: String(tab.indexOf),
                uid: '',
                valid: true
            }
        }
        return file
    }
    return (
        <div>
            <ListUserFiles
                onChange={newFile => {
                    if (newFile) setFile(newFile)
                    else {
                        setTemplate(undefined)
                        setFileName(undefined)
                    }
                }}
                select={getFile()}
            />
        </div>
    )
}

export { SelectHistoricalFile }
